"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REASON_INPUT = void 0;
const REASON_INPUT = exports.REASON_INPUT = 'reason-input';
